// extracted by mini-css-extract-plugin
module.exports = {"hero":"Header_hero__3bee0"};